interface HasGoogleCalendarStatus {
  googleCalendarConnected: boolean
  googleCalendarSynced: boolean
}

/** Adds a human-readable `calendarStatusLabel` field for display in an admin Table column. */
export function withCalendarStatusLabel<T extends HasGoogleCalendarStatus>(row: T): T & { calendarStatusLabel: string } {
  const calendarStatusLabel = !row.googleCalendarConnected ? 'Not connected' : row.googleCalendarSynced ? 'Synced' : 'Connected'
  return { ...row, calendarStatusLabel }
}
